type TrackingBeaconRaw = {
  resource_uri: string;
  id: string;
  tracking_type: string;
  event_id: string | null;
  user_id: string | null;
  organizer_id: string | null;
  pixel_id: string;
  triggers: Record<string, string>;
};

export type TrackingBeaconsResponse = {
  tracking_beacons?: TrackingBeaconRaw[];
};

export type TrackingBeacon = {
  pixelId: string;
  id: string;
  events: Record<string, string>;
};

export type TrackingBeacons = {
  [key: string]: TrackingBeacon[];
};

export const transformTrackingBeacons = (response: TrackingBeaconsResponse | undefined): TrackingBeacons | null => {
  if (!response?.tracking_beacons?.length) {
    return null;
  }

  const trackingBeacons: Record<string, TrackingBeacon[]> = {};

  response.tracking_beacons.forEach((beacon) => {
    trackingBeacons[beacon.tracking_type] = [
      ...(trackingBeacons[beacon.tracking_type] || []),
      {
        pixelId: beacon.pixel_id,
        id: beacon.id,
        events: beacon.triggers,
      },
    ];
  });

  return trackingBeacons;
};
